import { useEffect, useState } from "react";
import { MethodSystemContext } from "./MethodSystemContext";
import TypeSelection from "./components/TypeSelection";
import useModal from "../../hooks/useModal";

export default function MethodSystemProvider({ contracts = [], currencies = [], operators: availableOperators = [], reloadMethods = () => {} }) {
  const [view, setView] = useState(<TypeSelection />);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [id, setId] = useState(null);
  const [name, setName] = useState("");
  const [type, setType] = useState(null);
  const [contract, setContract] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [monthlyLimit, setMonthlyLimit] = useState(0);
  const [minAmount, setMinAmount] = useState(10);
  const [operators, setOperators] = useState([]);
  const [allowedContracts, setAllowedContracts] = useState([]);
  const [requiresKyc, setRequiresKyc] = useState(false);
  const [transactions, setTransactions] = useState([]);

  const [isEditing, setIsEditing] = useState(false);

  const { data } = useModal("method-system");


  useEffect(() => {
    if(data) {
      console.log("Received data for editing:", data);
      setType(data?.type || null);
      if(data?.id) setId(data.id);
      if(data?.contract) setContract(data.contract);
      if(data?.paymentMethod) setPaymentMethod(data.paymentMethod);
      if(data?.operators) setOperators(data.operators);
      if(data?.requiresKyc) setRequiresKyc(data.requiresKyc);
      if(data?.allowedContracts) setAllowedContracts(data.allowedContracts);
      if(data?.transactions) setTransactions(data.transactions);
      if(data?.monthlyLimit) setMonthlyLimit(data.monthlyLimit);
      if(data?.name) setName(data.name);
      if(data?.minAmount) setMinAmount(data.minAmount);
      
      setIsEditing(data?.type ? true : false);
    } else {
      setView(<TypeSelection />);
      setId(null);
      setLoading(false);
      setError(null);
      setName("");
      setType(null);
      setContract(null);
      setPaymentMethod(null);
      setMonthlyLimit(0);
      setOperators([]);
      setAllowedContracts([]);
      setRequiresKyc(false);
      setTransactions([]);
      setMinAmount(10);
      setIsEditing(false);
    }
  }, []);

  const networks = contracts.map(contract => contract.network).filter((value, index, self) => value && self.findIndex(v => v.id === value.id) === index);

  return (
    <MethodSystemContext.Provider value={{
      id, setId,
      view, setView,
      loading, error,
      type, setType,
      contract, setContract,
      paymentMethod, setPaymentMethod,
      operators, setOperators,
      requiresKyc, setRequiresKyc,
      allowedContracts, setAllowedContracts,
      transactions, setTransactions,
      monthlyLimit, setMonthlyLimit,
      name, setName,
      networks,
      minAmount, setMinAmount,
      contracts, currencies, availableOperators, isEditing,
      reloadMethods
    }}>
      {loading ? (
        <div className="flex-grow flex items-center justify-center">
          <div className="loader">Loading...</div>
        </div>
      ) : error ? (
        <div className="flex-grow flex items-center justify-center text-red-500">
          Error loading methods: {error.message}
        </div>
      ) : (
        <div className="flex-grow overflow-auto p-4 h-full">
          {view}
        </div>
      )}
    </MethodSystemContext.Provider>
  );
}